/**
 * Full-page navigation away from the app.
 *
 * Wrapped in a module of its own so that tests can replace it — and so that
 * "we are handing the browser to the payment provider" is a single, findable
 * call rather than a bare `window.location` assignment buried in a component.
 */
export function redirectTo(url: string): void {
  window.location.assign(url);
}
